// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { bellCheck16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-bell-check': IconBellCheck;
    }
}

/**
 * The icon component for the 'bellCheck' icon
 */
export class IconBellCheck extends Icon {
    public constructor() {
        super(bellCheck16X16);
    }
}

registerIcon('icon-bell-check', IconBellCheck);
export const iconBellCheckTag = 'nimble-icon-bell-check';
